import type { ReactNode } from 'react';

export interface PhotoHeroProps {
  src: string;
  alt?: string;
  height?: number;
  topLeft?: ReactNode;
  topRight?: ReactNode;
  bottomLeft?: ReactNode;
}

/**
 * Photo hero card with a gradient scrim at the bottom and three overlay
 * slots (top-left, top-right, bottom-left). The scrim provides legibility
 * for white-on-photo text without darkening the overall image.
 */
export function PhotoHero({
  src,
  alt = '',
  height = 180,
  topLeft,
  topRight,
  bottomLeft,
}: PhotoHeroProps) {
  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height,
        borderRadius: 20,
        overflow: 'hidden',
        background: 'var(--evi-surface-2)',
      }}
    >
      <img
        src={src}
        alt={alt}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
        }}
      />
      <div
        aria-hidden
        style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to top, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.0) 50%)',
          pointerEvents: 'none',
        }}
      />
      {topLeft && <div style={{ position: 'absolute', top: 12, left: 12 }}>{topLeft}</div>}
      {topRight && <div style={{ position: 'absolute', top: 12, right: 12 }}>{topRight}</div>}
      {bottomLeft && (
        <div
          style={{
            position: 'absolute',
            bottom: 12,
            left: 14,
            right: 14,
            color: '#FFFFFF',
          }}
        >
          {bottomLeft}
        </div>
      )}
    </div>
  );
}
